import EmptyState from './EmptyState.jsx'

export default function DataTable({ columns, rows, emptyTitle, emptyDescription, getRowKey, caption }) {
  if (rows.length === 0) return <EmptyState compact title={emptyTitle} description={emptyDescription} />
  return (
    <div className="table-wrap">
      <table>
        {caption && <caption className="sr-only">{caption}</caption>}
        <thead><tr>{columns.map((column) => <th scope="col" key={column.key}>{column.label}</th>)}</tr></thead>
        <tbody>{rows.map((row, index) => <tr key={getRowKey?.(row) || index}>{columns.map((column) => <td key={column.key} className={column.className || ''}>{column.render ? column.render(row) : row[column.key] ?? '—'}</td>)}</tr>)}</tbody>
      </table>
    </div>
  )
}
